<template>
  <div class="question_text">
    <p>В этом разделе представлено максимальное количество полей анкеты для проектов.</p>
    <p>Необязательно заполнять их все!</p>
    <p>Чтобы узнать, какие поля нужно заполнить, в разделе «Конкурсы» выберите, интересующий вас конкурс. На
      странице конкурса нажмите «Подать заявку». Выберите проект, который хотите
      подать на этот конкурс – появится список обязательных полей, которые требуются
      для этого конкурса.</p>
    <p>Если проект еще не создан, нажмите «Добавить проект» и в нем
      нажмите «Перейти к отправке на конкурс» - вы увидите список необходимых полей.</p>
  </div>
</template>

<script>
export default {
  name: "QuestionText1"
}
</script>

<style scoped>
.question_text {
    text-align: left;
    font-size: 16px;
    margin: 30px auto 30px;
    width: 80%;
    max-width: 950px;
}

</style>